import * as type from './type';
export default {
    [type.SET_INVOICE_INFO](state, invoiceInfo) {
        state.invoiceInfo = invoiceInfo;
    },

    [type.SET_LOGISTICS](state, logisticDetail) {
        state.logisticDetail = logisticDetail;
    },

    [type.SET_INVOICE_APPLY_DETAIL](state, invoiceApplyDetail) {
        state.invoiceApplyDetail = invoiceApplyDetail;
    },
}


// WEBPACK FOOTER //
// ./src/store/invoice-manage/mutations.js